import React from "react";
import { config } from "../services/Config";
const apiUrl = config.apiUrl;
const baseUrl = config.baseUrl;

export const VALIDATE_TOKEN = apiUrl + "validate-user";
export const LOGIN_URL = apiUrl + "v1/signin";
export const ASSET_URL = config.asset_url;
export const S3_URL = config.s3Url;
export const GET_FINANCIALS = apiUrl + "v1/get-financials";
export const POST_TRANSACTION = apiUrl + "v1/post-transaction";
export const GET_DEPOSITS = apiUrl + "v1/get-deposits";
export const POST_WITHDRAWALS = apiUrl + "v1/post-withdrawal";
export const GET_WITHDRAWALS = apiUrl + "v1/get-withdrawals";
export const POST_NEW_BANK = apiUrl + "v1/post-client-bank";
export const GET_CLIENT_BANKS = apiUrl + "v1/get-client-banks";
export const GET_DEPOSIT_BANKS = apiUrl + "v1/get-deposit-banks";
export const UPLOAD_ATTACHMENT = apiUrl + "v1/upload-media";
export const GET_BANKS_LIST = apiUrl + "v1/banks-list";
export const GET_SEARCH_BANK = apiUrl + "v1/search-bank";
export const GET_REFERRALS = apiUrl + "v1/referrals";
export const SEND_OTP_URL = apiUrl + "v1/send-otp";
export const CLIENT_OTP_URL = apiUrl + "v1/client-otp";
export const OTP_AUTH_URL = apiUrl + "v1/otp-auth";
export const GET_LOYALTY = apiUrl + "v1/get-loyalty";
export const DELETE_CLIENT_BANK = apiUrl + "v1/delete-client-bank";
export const VERIFY_OTP_URL = apiUrl + "v1/verify-client-otp";
export const RESET_PASSWORD_URL = apiUrl + "v1/reset-password";
export const VERIFY_OTP = apiUrl + "v1/verify-otp";
export const RESET_PASSWORD = apiUrl + "v1/reset-password";
export const GET_WITHDRAWAL_AMOUNT = apiUrl + "v1/get-withdrawable-amount";
export const FORGET_USERNAME_URL = apiUrl + "v1/forget-username";
export const TOP_GAINERS_URL = apiUrl + "v1/top-gainers";
export const TOP_LOSERS_URL = apiUrl + "v1/top-losers";
export const DESCENDENT_COMMISSIONS = apiUrl + "v1/descendent-commissions";
export const GET_MARKETDATA = apiUrl + "v1/market-data";
